import styled from 'styled-components'

const severityBg = {
  success: 'var(--vo-success-10)',
  error: 'var(--vo-danger-10)',
  warning: 'var(--vo-warning-10)',
  info: 'var(--vo-info-10)',
}

const severityColor = {
  success: 'var(--vo-success)',
  error: 'var(--vo-danger)',
  warning: 'var(--vo-warning)',
  info: 'var(--vo-info)',
}

export const AlertWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border-radius: var(--radius-lg);
  background-color: ${({ $severity }) => severityBg[$severity] || severityBg.info};
  border: 1px solid ${({ $severity }) => severityColor[$severity] || severityColor.info};
`

export const AlertIcon = styled.span`
  flex-shrink: 0;
  margin-right: 10px;
  font-size: 18px;
  line-height: 1.4;
  color: ${({ $severity }) => severityColor[$severity] || severityColor.info};
`

export const AlertContent = styled.div`
  flex: 1;
  color: var(--vo-ink);
  font-size: 14px;
  line-height: 1.5;
`
